// extracted by mini-css-extract-plugin
export default {"root":"quoted-tweet-container_root__s5Ao1","article":"quoted-tweet-container_article__c8Los"};